import React, { useRef, useState, useEffect } from "react";
import SmiWidget from "../../components/smiWidgets/SmiWidget";

// Липкость колонки задана в CSS (`.sticky-block-content { position: sticky }`), причём
// сразу в нескольких файлах. Поэтому выключаем её инлайном, а не убираем правило: при
// isSticky=true разметка не меняется вовсе, а при false инлайн перебивает любой из них.
export const SideBar = ({ isFull, isDesktop, widgetBlocks, isSticky = true }) => {
    const [visibleWidgets, setVisibleWidgets] = useState(1);
    const divRef = useRef(null);

    useEffect(() => {
        const updateDivHeight = () => {
            if (divRef.current) {
                const height = divRef.current.offsetHeight;
                if (height < 450) {
                    setVisibleWidgets(1);
                } else if (height < 700) {
                    setVisibleWidgets(2);
                } else if (height < 1000) {
                    setVisibleWidgets(3);
                } else {
                    setVisibleWidgets(4);
                }
            }
        };
        updateDivHeight();
        window.addEventListener("resize", updateDivHeight);
        return () => {
            window.removeEventListener("resize", updateDivHeight);
        };
    }, []);

    return (
        <div className="sticky-block" ref={divRef}>
            <div className="sticky-block-content" style={isSticky ? undefined : { position: "static" }}>
                <SmiWidget
                    isDesktop={isDesktop}
                    isFull={isFull}
                    blockIds={widgetBlocks}
                    visibleWidgets={visibleWidgets}
                />
            </div>
        </div>
    );
};
